export default __webpack_public_path__ + "static/media/1857.dbf6d38b.png";